// extracted by mini-css-extract-plugin
var _1 = "InsightsRestriction-module__animateUploadProgressBarWidth--diaXm";
var _2 = "InsightsRestriction-module__animatedBackground--LUlvH";
var _3 = "InsightsRestriction-module__container--N1WJx";
var _4 = "InsightsRestriction-module__note--_n9g_";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "note" }
